import Dialog from "../../atoms/dialog";
import { Button, Typography, Box } from "@material-ui/core";
import { useState, useEffect, Fragment } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import DeleteAnalytics from "../analytics/DeleteAnalytics";



const DeleteAnalyticsAlert = (props) => {
    const { onCompletion, setShowDeleteAlert, element, onClose } = props;


    const [open, setOpen] = useState(false)


    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (

        <Dialog
            // title={"Delete"}
            open={true}
            handleClose={handleClose}
        >

            <DeleteAnalytics onCompletion={onCompletion} setShowDeleteAlert={setShowDeleteAlert} element={element} onClose={onClose} />

        </Dialog >
    )

}

export default DeleteAnalyticsAlert;